<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Questionnaire">
          <b-form-textarea v-model="componentModelSection.titre" required placeholder="Entrez le questionnaire" />
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <b-form-group label="Nombre d'Entrée">
          <numeric-input v-model="nombres" inline :min="0" :max="100" :step="1"/>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <b-form-group>
          <b-card-text class="mb-0">Objectif Active</b-card-text>
          <b-form-checkbox v-model="componentModelSection.objectif" name="objectif-checkbox" switch inline>
            Objectif
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <label for="tags-basic">Tapez une nouvelle Question et appuyez sur Entrée</label>
    <b-form-tags v-model="listTag" no-outer-focus @input="updateComponentModelTitle">
      <template v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
        <b-input-group aria-controls="my-custom-tags-list">
          <input v-bind="inputAttrs" placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                 class="form-control" v-on="inputHandlers" />
          <b-input-group-append>
            <b-button variant="primary" @click="addTag()">Ajouter</b-button>
          </b-input-group-append>
        </b-input-group>
        <ul id="my-custom-tags-list" class="list-unstyled d-inline-flex flex-wrap mb-0" aria-live="polite"
            aria-atomic="false" aria-relevant="additions removals">
          <b-card v-for="tag in tags" :key="tag" tag="li" class="shadow-none border mt-1 mr-1 mb-0"
                  body-class="py-1 pr-2 text-nowrap">
            <strong>{{ tag }}</strong>

            <b-button variant="link" size="sm" class="py-0" @click="removeTag(tag)">
              <feather-icon icon="XIcon" />
            </b-button>
            <b-button variant="link" size="sm" @click="getTagValue(tag)">
              <feather-icon icon="InfoIcon" />
            </b-button>
          </b-card>
        </ul>

      </template>
    </b-form-tags>
    <b-card v-for="(section, index) in componentModelSection.contentSections" :key="index" no-body
            class="invoice-preview-card">
      <b-card-body class="invoice-padding pb-0">
        <b-row>
          <b-col cols="6">
            <b-form-group label="Questionnaire">
              <b-form-textarea v-model="section.titre" required placeholder="Entrez le questionnaire" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="Type de réponse">
              <v-select v-model="section.champsModel" :options="champsEnumOptions"
                        placeholder="Sélectionnez un type de réponse" required />
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label="Info-Bulle">
              <b-form-input v-model="section.description" placeholder="Entrez une info-bulle" />
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label="Incrementation maximale">
              <numeric-input v-model="section.max" :min="0" :max="100" :step="1" />
            </b-form-group>
          </b-col>

          <!-- Taille de Composant Spin Button -->
          <b-col cols="4">
            <b-form-group label="Taille de composant">
              <numeric-input v-model="section.taille" :min="0" :max="12" :step="1" />
            </b-form-group>
          </b-col>

          <!-- Obligatoire Checkbox -->
          <b-col cols="4">
            <b-form-group label="Composant Obligatoire">
              <b-form-checkbox v-model="section.required" switch inline>
                Obligatoire
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label="Lecture seule">
              <b-form-checkbox v-model="section.readonly" switch inline :true-value="'readonly'" :false-value="null">
                Lecture seule
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- Somme Checkbox -->
          <b-col cols="4">
            <b-form-group label="Somme">
              <b-form-checkbox v-model="section.somme" switch inline>
                Somme
              </b-form-checkbox>
            </b-form-group>

            <!-- <b-form-checkbox v-model="section.somme">
              Somme Unique
            </b-form-checkbox> -->
          </b-col>

          <!-- Réponse à afficher dans le récapitulatif -->
          <b-col cols="12">
            <b-form-group label="Afficher la réponse dans le récapitulatif ?">
              <b-form-checkbox v-model="section.reponse" switch inline>
                Réponse
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Section Somme -->
        <template v-if="section.somme">
          <hr />
          <b-card-body>
            <!-- Section Selection -->
            <b-col cols="12" xl="12">

              <b-form-group label="Section">
                <v-select v-model="selectedSectionId" :options="sections" :reduce="section => section.idPublic" label="title"
                          placeholder="Sélectionnez une section" required />
              </b-form-group>
            </b-col>


            <b-col cols="12" xl="12">
              <b-form-group label="Liste des questions">
                <v-select label="titre" :options="componentsModalSommeList"
                          v-model="selectedcomponentsModalSommeList" />
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12">
              <b-form-group label="Liste de question">
                <v-select v-model="section.componentModel" multiple label="titre"
                          :options="selectedcomponentsModalSommeList.componentModels" />
              </b-form-group>
            </b-col>
            <b-col cols="12" xl="12">
              <b-form-group label="La réponse a sommé">
                <v-select v-model="section.contentSection" label="titre"
                          :options="selectedcomponentsModalSommeList.contentSections" @input="setSommeContentIds(section)" />
              </b-form-group>
            </b-col>
          </b-card-body>
        </template>

      </b-card-body>


      <div v-if="isListeType(section.champsModel)">
        <hr />

        <label for="tags-basic">Tapez une nouvelle valeur et appuyez sur Entrée</label>
        <b-form-tags v-model="section.valueList" no-outer-focus>
          <template v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
            <b-input-group aria-controls="my-custom-tags-list">
              <input v-bind="inputAttrs" placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                     class="form-control" v-on="inputHandlers">
              <b-input-group-append>
                <b-button variant="primary" @click="addTag()">Ajouter</b-button>
              </b-input-group-append>
            </b-input-group>
            <ul id="my-custom-tags-list" class="list-unstyled d-inline-flex flex-wrap mb-0" aria-live="polite">
              <b-card v-for="tag in tags" :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" :key="tag" tag="li"
                      class="shadow-none border mt-1 mr-1 mb-0" body-class="py-1 pr-2 text-nowrap">
                <strong>{{ tag }}</strong>
                <b-button variant="link" size="sm" @click="removeTag(tag)" class="py-0">Supprimer</b-button>
                <!-- <b-button variant="link" size="sm" @click="getTagInterge(tag)" class="py-0">
                  <feather-icon icon="AlertCircleIcon" />
                </b-button> -->

              </b-card>
            </ul>
          </template>
        </b-form-tags>
      </div>

    </b-card>
    <b-modal v-model="isModalVisible" @hide="resetModalInfo" :title="selectedComponentModel.titre"
             @ok="updateComponentModel">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Info-Bulle">
            <b-form-input v-model="selectedComponentModel.description" />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Taille de composant">
            <label for="sb-inline" class="mr-1">Min 1 et Max 12</label>
            <numeric-input id="sb-inline" v-model="selectedComponentModel.taille" :min="0" :max="100" :step="1" />
          </b-form-group>
        </b-col>
        <b-col cols="6" xl="6">
          <b-form-group label="Somme ">
            <b-form-checkbox v-model="selectedComponentModel.somme" name="check-button" switch inline>
              Somme
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="6" xl="6">

          <b-form-group label="Le poids de la question">
            <label for="sb-inline" class="mr-1">Min 1 et Max 100</label>
            <numeric-input id="sb-inlinenote" v-model="selectedComponentModel.note" inline :min="0" :max="100" :step="1" />
          </b-form-group>
        </b-col>
      </b-row>

      <hr v-if="selectedComponentModel.somme" />
      <div v-if="selectedComponentModel.somme">
        <b-card-body class="invoice-padding pb-0">

          <b-row>
            <b-col cols="12" xl="12">
              <b-form-group label="Section">
                <v-select :options="sections" :reduce="section => section.idPublic" label="title" v-model="selectedSectionId"
                          required>
                </v-select>
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12">
              <b-form-group label="Liste des modules">
                <v-select label="titre" :options="componentsModalSommeList"
                          v-model="selectedcomponentsModalSommeList" />
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12">
              <b-form-group label="Liste de question">
                <v-select v-model="selectedComponentModel.componentModel" multiple label="titre"
                          :options="selectedcomponentsModalSommeList.componentModels" />
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12">
              <b-form-group label="La réponse a sommé">
                <v-select v-model="selectedComponentModel.contentSection" label="titre"
                          :options="selectedcomponentsModalSommeList.contentSections"
                          @input="setSommeContentId(selectedComponentModel)" />
              </b-form-group>
            </b-col>

          </b-row>
        </b-card-body>

      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  BFormTags,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BCard,
  BCardBody,
  BFormCheckbox
} from 'bootstrap-vue';
import vSelect from "vue-select";
import { allSectionComponentModelSections } from "@/services/ComponentModelSectionService";
import NumericInput from "@/util/NumericInput.vue";

export default {
  components: {
    BFormCheckbox,
    NumericInput,
    BRow,
    BCol,
    BFormGroup,
    BFormTextarea,
    BFormTags,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BCard,
    BCardBody,
    vSelect
  },
  props: {
    champsEnumOptions: {
      type: Array,
      required: true,
    },
    componentModelSection: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      listTag: [],
      selectedTag: null,
      nombres: 1,
      selectedComponentModel: {

        taille: 0,
        note: 0,
        contentSection: {},
        componentModel: []
      },
      isModalVisible: false,
      componentsModalSommeList: [],
      selectedSectionId: null,
      selectedcomponentsModalSommeList: {
        titre: '',
        contentSections: [],
        componentModels: []
      },
      sommeContent: {
        contentSection: {
          titre: null
        },
        componentModel: [],
        contentSections:{idPublic :null},
      },
      localcomponentModelSection: { ...this.componentModelSection },

    }
  },

  methods: {
    setSommeContentIds(section) {
      this.sommeContent.contentSections.idPublic = section.idPublic;
    },

    setSommeContentId(section) {


    },
    updateComponentModelSection() {

      this.$emit('update:componentModelSection', this.localcomponentModelSection);
    },
    isStandardSection() {

      const selectedSection = this.sections.find(section => section.idPublic === this.selectedSectionId);
      return selectedSection && selectedSection.type === 'standard';
    },
    resetModalInfo() {
      this.selectedSectionId = null,

          this.selectedcomponentsModalSommeList = {
            titre: '',
            contentSection: [],
            componentModels: []
          },
          this.selectedComponentModel = {
            taille: 0,
            note: 0,
            contentSection: {},
            componentModel: []
          }
    },
    updateComponentModelTitle() {
      this.componentModelSection.componentModels = this.listTag.map((tag, index) => {
        return {
          ...this.componentModelSection.componentModels[index],
          titre: tag
        };
      });
    },
    getTagValue(tag) {
      this.selectedTag = tag;


      this.selectedComponentModel = this.componentModelSection.componentModels.find(model => model.titre === tag);

      if (this.selectedComponentModel) {
        this.isModalVisible = true;
      } else {
        console.error('Aucun modèle trouvé pour le tag:', tag);
      }
    },
    // getTagInterge(){

    // },
    isListeType(champsModel) {
      return champsModel?.type === 'liste';
    },
    async updateContentAndComponentModels(sectionId) {
      try {
        this.componentsModalSommeList = await allSectionComponentModelSections(sectionId);
        // this.componentsModalSommeList = this.componentModelSectionList;
      } catch (error) {
        console.error("Erreur lors de la mise à jour des champs :", error);
      }
    },
    updateComponentModel() {
      const index = this.componentModelSection.componentModels.findIndex(model => model.titre === this.selectedTag);
      if (index !== -1) {
        this.componentModelSection.componentModels.splice(index, 1, this.selectedComponentModel);
      }
      this.updateComponentModelSection();
      this.isModalVisible = false;

    },
  },
  watch: {
    componentModelSection: {
      handler: function (newVal) {
        this.localcomponentModelSection = { ...newVal };
      },
      deep: true,
    },
    nombres(newVal) {
      // Adjust the number of contentSections to match nombres

      const currentLength = this.componentModelSection.contentSections.length;


      if (newVal > currentLength) {
        // Add new sections
        for (let i = currentLength; i < newVal; i++) {
          this.componentModelSection.contentSections.push({
            titre: '',
            champsModel: null,
            description: '',
            required: false,
            taille: 1
          });
        }
      } else if (newVal < currentLength) {
        // Remove excess sections
        this.componentModelSection.contentSections.splice(newVal);
      }
      this.updateComponentModelSection();

    },
    selectedSectionId: {
      handler: function (newVal) {
        if (newVal) {
          this.updateContentAndComponentModels(newVal);

        }
      }
    },
  }


}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  transition: .35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: #283046;
    }
  }
}

.raf-accordion .card-header {
  padding: 1.5rem;
}

.raf-accordion .card-body {
  padding: 0 1.5rem 1.5rem 1.5rem;
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
